export { default } from './DocumentText'
